import React from 'react';
import { hasProductFlagTag } from '../../../Utils/Helpers';

interface BadgeProductTagFlagProps {
    product: any;
    className?: string;
}

const BadgeProductTagFlag = ({
    product,
    className,
}: BadgeProductTagFlagProps) => {

    if (!product) return null;

    const tags = Array.isArray(product.tags) ? product.tags : [];

    if (hasProductFlagTag(tags)) {
        return (
            <div className={`${className}`}>
                <img alt="Test" className='min-w-4 max-w-4 min-h-4 max-h-4 rounded-full' src='https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Brazilian_Flag_-_round.svg/960px-Brazilian_Flag_-_round.svg.png' />
            </div>
        );
    }

    return null;
};

export default BadgeProductTagFlag;
